<template>
	<div class="mx-auto">
		<iframe height="800" width="100%" src="SASL_Online_Activation_Guide.pdf" />
	</div>
</template>
